export { };
// @ts-expect-error
String.prototype.removeAccents = function (this: string): string {
    return this.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
// @ts-expect-error
String.prototype.isNullOrEmpty = function (this: string): boolean {
    return !this;
}
